import { useEffect, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Textarea } from "@/components/ui/textarea";

export const NoteEditor = ({ loungeId, note = "", onSave, children }) => {
  const [open, setOpen] = useState(false);
  const [val, setVal] = useState(note);

  useEffect(() => { if (open) setVal(note || ""); }, [open, note]);

  const save = () => { onSave(loungeId, val); setOpen(false); };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent align="end" className="w-64 p-3" data-testid="note-editor">
        <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500">
          Lounge note
        </p>
        <Textarea
          data-testid="note-input"
          value={val}
          onChange={(e) => setVal(e.target.value)}
          placeholder="Allergies, VIP setup, high-chair…"
          className="min-h-[76px] text-xs"
        />
        <div className="mt-2 flex gap-2">
          <button
            data-testid="note-save-btn"
            onClick={save}
            className="h-8 flex-1 rounded-lg bg-slate-900 text-xs font-semibold text-white hover:bg-slate-800"
          >
            Save
          </button>
          {note && (
            <button
              data-testid="note-clear-btn"
              onClick={() => { onSave(loungeId, ""); setOpen(false); }}
              className="h-8 rounded-lg px-3 text-xs font-semibold text-destructive hover:bg-destructive/10"
            >
              Clear
            </button>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};
